import {GsPublication} from "../../utils/types";
import React, {ReactElement} from "react";
import {Tooltip} from 'antd';
import ComponentFromString from '../../utils/ComponentFromString';
import { Html5Entities } from 'html-entities';
const htmlEntities = new Html5Entities();

interface GsPublicationTitleProps {
    gsPub: GsPublication
}

const GsPublicationTitle = ({gsPub}: GsPublicationTitleProps) => {
    let title;
    let titleContent = gsPub && gsPub.title;
    let component;
    if (titleContent) {
        // firstly we need to decode some html entities such as decode &amp; to &
        titleContent = htmlEntities.decode(titleContent);

        component = ComponentFromString(titleContent)
    }
    if (gsPub && gsPub.gs_url) {
        title = (
            <Tooltip overlayClassName="sub-heading-font" title='google scholar page' placement="topLeft">
                <a href={gsPub.gs_url}
                   target="_blank"
                   rel="noopener noreferrer"
                   className="sfu-red-link"
                >{titleContent?component:'[No title available]'}</a>
            </Tooltip>
        )
    } else if (titleContent) {
        title = component;
    } else {
        title = ''
    }
    return title as ReactElement;
};

export default GsPublicationTitle;